import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function joinIds(
  ...ids: (string | false | null | undefined)[]
): string | undefined {
  return ids.filter(Boolean).join(' ') || undefined
}
